'use client';

import {
  NavigationDrawerItem,
  NavigationDrawerRow,
  NavigationDrawerRowLabel,
  NavigationDrawerRowMain,
  NavigationDrawerRowMark,
} from '@vs-shop/commerce-ui/navigationDrawer';
import { ChevronRight } from 'lucide-react';
import { useIntl } from 'react-intl';

type Props = {
  onViewAllClickAction: () => void;
};

export default function MobileNavigationViewAllButton({ onViewAllClickAction }: Props) {
  const intl = useIntl();

  return (
    <NavigationDrawerItem>
      <NavigationDrawerRow variant="standard" onClick={onViewAllClickAction}>
        <NavigationDrawerRowMain>
          <NavigationDrawerRowLabel>
            {intl.formatMessage({
              id: 'component.server.navigation.mobile.mobileNavigationViewAllButton.viewAll',
              defaultMessage: 'Prohlédnout všechno',
            })}
          </NavigationDrawerRowLabel>
        </NavigationDrawerRowMain>

        <NavigationDrawerRowMark variant="static">
          <ChevronRight strokeWidth={1} />
        </NavigationDrawerRowMark>
      </NavigationDrawerRow>
    </NavigationDrawerItem>
  );
}
